import React, { HTMLAttributes } from "react";
import FloatingDiv from "components/FloatingDiv/FloatingDiv";
import IconType from "@cc/react-components/IconType";
import { Button } from "@cc/react-components";

export interface Props extends HTMLAttributes<HTMLDivElement> {
  /**
   * Type of the icon to display in the button
   */
  icon: IconType;
  /**
   * The placement on the screen
   * @default 'bottom'
   */
  placement?: "bottom" | "top";
  /**
   * The side on the screen
   * @default 'right'
   */
  side?: "left" | "right";
  /**
   * Action called when clicking on the button.
   */
  action?: () => void;
}

const FloatingButton = ({
  icon,
  placement = "bottom",
  side = "right",
  action,
  ...props
}: Props) => {
  return (
    <FloatingDiv placement={placement} side={side}>
      <Button
        variant="floating-primary"
        size="lg"
        icon={icon}
        onClick={action}
      />
    </FloatingDiv>
  );
};

export default FloatingButton;
